import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  const lp = (path) => `/${language}${path}`;

  return (
    <footer className="bg-[#0f172a] text-white py-16" data-testid="footer">
      <div className="vf-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="space-y-4">
            <Link to={lp('')} className="flex items-center gap-2">
              <img src="/logo.png" alt="VendFactura" className="h-14 w-auto object-contain" />
            </Link>
            <p className="text-slate-400 text-sm">{t('footer_description')}</p>
            <div className="flex items-center gap-2 text-sm text-slate-400">
              <Heart className="w-4 h-4 text-red-500 fill-current" />
              <span>{t('footer_made')}</span>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer_product')}</h4>
            <ul className="space-y-3">
              <li><a href={`/${language}#features`} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_features')}</a></li>
              <li><Link to={lp('/pricing')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_pricing')}</Link></li>
              <li><Link to={lp('/mobile')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_mobile')}</Link></li>
              <li><Link to={lp('/faq')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_faq')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer_company')}</h4>
            <ul className="space-y-3">
              <li><Link to={lp('/about')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_about')}</Link></li>
              <li><Link to={lp('/contact')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('nav_contact')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer_legal')}</h4>
            <ul className="space-y-3">
              <li><Link to={lp('/terms')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('footer_terms')}</Link></li>
              <li><Link to={lp('/privacy')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('footer_privacy')}</Link></li>
              <li><Link to={lp('/cookies')} className="text-slate-400 hover:text-white transition-colors text-sm">{t('footer_cookies')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">{t('footer_copyright')}</p>
          <div className="flex items-center gap-6">
            <a href="mailto:info@vendfactura.es" className="text-slate-400 hover:text-white transition-colors"><Mail className="w-5 h-5" /></a>
            <a href="tel:+34900000000" className="text-slate-400 hover:text-white transition-colors"><Phone className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
